import * as _ from 'lodash';
import { useState } from 'react';
import { Panel, ListGroup, PanelGroup } from 'react-bootstrap';
import { IEmailFlag, IEmailFlagGroup, IEmailFlagValue } from '@nkr/models/index';
import EmailOptionItem from './email-option-item';

interface IProps {
    data: IEmailFlagValue[],
    emailFlags: IEmailFlag[],
    emailFlagGroups: IEmailFlagGroup[],
    onChange: (list: IEmailFlagValue[]) => void
}

const EmailOptions = (props: IProps) => {
    const [selectedEmailOption, setSelectedEmailOption] = useState(-1);

    const handlePanelSelected = (activeKey: any) => {
        setSelectedEmailOption(parseInt(activeKey));
    }

    const handleChangeEmailFlag = (flagId: number, value: number) => {
        let emailFlags = _.cloneDeep(props.data);
        let flag = emailFlags.find(x => x.flag == flagId);

        if (flag != null) {
            flag.value = value;
        } else {
            emailFlags.push({ flag: flagId, value });
        }

        props.onChange(emailFlags);
    }

    const handleChangeGroupFlag = (groupId: number, enable: boolean) => {
        let emailFlags = _.cloneDeep(props.data);
        let flags = props.emailFlags.filter(x => x.groupId == groupId);

        flags.forEach(flag => {
            let f = emailFlags.find(x => x.flag == flag.id);

            if (f != null) {
                f.value = enable ? 1 : 0;
            } else {
                emailFlags.push({ flag: flag.id, value: enable ? 1 : 0 });
            }
        });

        props.onChange(emailFlags);
    }

    const data = props.data;

    return (
        <Panel>
            <Panel.Heading>Receive Email Options</Panel.Heading>
            <Panel.Body>
                <PanelGroup accordion id='email-options' style={{ marginBottom: 0 }} activeKey={selectedEmailOption} onSelect={handlePanelSelected}>
                    {props.emailFlagGroups.map((group, groupIndex) => {
                        const flags = props.emailFlags.filter(x => x.groupId == group.id);

                        return (
                            <Panel key={groupIndex} eventKey={groupIndex}>
                                <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 7.5px' }}>
                                    <Panel.Title style={{ fontSize: 12 }} toggle>{group.groupName}</Panel.Title>
                                    <div>
                                        <a style={{ fontSize: 12, cursor: 'pointer' }} onClick={() => handleChangeGroupFlag(group.id, true)}>Enable All</a>&nbsp;/&nbsp;<a style={{ fontSize: 12, cursor: 'pointer' }} onClick={() => handleChangeGroupFlag(group.id, false)}>Disable All</a>
                                    </div>
                                </Panel.Heading>
                                <Panel.Collapse>
                                    <ListGroup>
                                        {flags.map((flag, flagIndex) => {
                                            let f = data.find(x => x.flag == flag.id);

                                            return (
                                                <EmailOptionItem
                                                    key={`email-option-${groupIndex}-${flagIndex}`}
                                                    groupIndex={groupIndex}
                                                    itemIndex={flagIndex}
                                                    flag={flag}
                                                    value={f != null ? f.value : 0}
                                                    onChange={handleChangeEmailFlag}
                                                />
                                            );
                                        })}
                                    </ListGroup>
                                </Panel.Collapse>
                            </Panel>
                        );
                    })}
                </PanelGroup>
            </Panel.Body>
        </Panel>
    );
}

export default EmailOptions;